/* global axios */
import ApiClient from './ApiClient';

// Cliente pro endpoint de configuracao do Lead Scoring — feature nativa
// extraida do modulo VOIP. Inclui run_now pra trigger sob demanda.
class LeadScoringConfigAPI extends ApiClient {
  constructor() {
    super('lead_scoring_config', { accountScoped: true });
  }

  show() {
    return axios.get(this.url);
  }

  update(payload) {
    return axios.patch(this.url, { lead_scoring_config: payload });
  }

  runNow() {
    return axios.post(`${this.url}/run_now`);
  }
}

export default new LeadScoringConfigAPI();
